import { ADMIN_SECTIONS } from '../constants/adminSections';

// Mirrors backend/src/utils/staff.ts — keep the two in step. A super admin may
// do everything; an admin only the modules a super admin picked for them.

export type PlatformRole = 'superadmin' | 'admin' | 'user';

export interface StaffSubject {
  role?: string | null;
  adminModules?: readonly string[] | null;
}

export const ROLE_LABEL: Record<PlatformRole, string> = { superadmin: 'Super admin', admin: 'Admin', user: 'User' };

export const roleLabel = (role: string | null | undefined): string => ROLE_LABEL[role as PlatformRole] ?? 'User';

export const ADMIN_MODULES = ADMIN_SECTIONS.map((s) => ({ key: s.module, label: s.title }));

export const isSuperAdmin = (u: StaffSubject | null | undefined): boolean => u?.role === 'superadmin';

export const isStaff = (u: StaffSubject | null | undefined): boolean => isSuperAdmin(u) || u?.role === 'admin';

export const hasAdminModule = (u: StaffSubject | null | undefined, module: string): boolean =>
  isSuperAdmin(u) || (u?.role === 'admin' && !!u.adminModules?.includes(module));

// The All Projects module is what lets an admin open and change any project.
export const seesAllProjects = (u: StaffSubject | null | undefined): boolean => hasAdminModule(u, 'projects');

export const sectionsFor = (u: StaffSubject | null | undefined) => ADMIN_SECTIONS.filter((s) => hasAdminModule(u, s.module));
